/**
 * @generated SignedSource<<3ad4691d5697dcda364abec227f631ab>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavBoardHeader_project$data = {
  readonly canEditProjectConfig?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly created?: AGG$DateTime | null | undefined;
  readonly projectId?: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BoardActions" | "ExtraComponentsFar" | "HorizontalNavProjectBreadcrumbs" | "NavigationInviteButton_project" | "NavigationTeamButton_project">;
  readonly " $fragmentType": "HorizontalNavBoardHeader_project";
};
export type HorizontalNavBoardHeader_project$key = {
  readonly " $data"?: HorizontalNavBoardHeader_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavBoardHeader_project">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "isTMPBoardRoute"
    }
  ],
  "kind": "Fragment",
  "name": "HorizontalNavBoardHeader_project",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "NavigationTeamButton_project"
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjirainvitebuttonrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "NavigationInviteButton_project"
        },
        {
          "alias": "canEditProjectConfig",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "EDIT_PROJECT_CONFIG"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "canPerform"
            }
          ],
          "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
        },
        {
          "kind": "ScalarField",
          "name": "projectId"
        },
        {
          "kind": "ScalarField",
          "name": "created"
        }
      ]
    },
    {
      "condition": "isTMPBoardRoute",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "BoardActions"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "ExtraComponentsFar"
    },
    {
      "kind": "FragmentSpread",
      "name": "HorizontalNavProjectBreadcrumbs"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "fdd133f34e3259bb83483c754bd92e4c";

export default node;
